module.exports = __webpack_public_path__ + "img/5.259c78fd.jpg";